import { render, staticRenderFns } from "./SearchProvider.vue?vue&type=template&id=23f94b00&scoped=true&"
import script from "./SearchProvider.vue?vue&type=script&lang=ts&"
export * from "./SearchProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f94b00",
  null
  
)

export default component.exports